import React from "react";
import styled from "styled-components";
import { getMargin, MarginDescription } from "../CareConnectMobile-Theme";

export interface Props extends React.HTMLAttributes<HTMLElement> {
  /** Adds margin on all sides of container */
  all?: MarginDescription;
  left?: MarginDescription;
  top?: MarginDescription;
  right?: MarginDescription;
  bottom?: MarginDescription;
  /** Set the container to use full width */
  fullWidth?: boolean;
  /** Set the container to user full height */
  fullHeight?: boolean;
  /** Transform the div */
  transform?: string;
}

/**
 * A simple container for layout that adds margins to the sides.
 */
const SpacerContainer = ({
  all,
  left,
  top,
  right,
  bottom,
  fullWidth,
  fullHeight,
  transform,
  children,
  ...props
}: Props) => {
  return <div {...props}>{children}</div>;
};

export default styled(SpacerContainer)`
  margin: ${(props) => props.all && getMargin(props.all)};
  margin-left: ${(props) => props.left && getMargin(props.left)};
  margin-top: ${(props) => props.top && getMargin(props.top)};
  margin-right: ${(props) => props.right && getMargin(props.right)};
  margin-bottom: ${(props) => props.bottom && getMargin(props.bottom)};
  height: ${(props) => props.fullHeight && `100%`};
  width: ${(props) => props.fullWidth && `100%`};
  transform: ${(props) => props.transform};
`;
